<!-- 
  name: 催收案件
  desc: 催收模块-催收案件
  auth: dhx
  update: 2024/2/22
 -->
<template>
  <div class="index">
    <el-tabs v-model="activeName" @tab-click="handleClick" size="large">
      <el-tab-pane
        v-for="(item, index) in tabOptions"
        :label="item.label"
        :name="item.name"
        :key="index"
      ></el-tab-pane>
    </el-tabs>

    <!-- <component :is="componentId"></component> -->

    <Search  @update-parent="handleUpdate"></Search>
    <cases-table :paramsList="list" @openModel="openModel"></cases-table>
    <batch-send-model ref="modelRef"></batch-send-model>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import options from "./contact";
export default options;
</script>

<style lang="scss" scoped>
@import url("./style.scss");
</style>



// WEBPACK FOOTER //
// src/views/collection/collection_cases/index.vue